import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListOrder from './pages/ListOrder';
import OrderDetailPage from './pages/OrderDetail';
import OrderHistory from './pages/OrderHistory';
import OrderHistoryNew from './pages/OrderHistoryNew';
import OrderHistoryDetail from './pages/OrderHistoryDetail';

const Order = () => {
  return (
    <Routes>
      <Route path=":id" element={<OrderDetailPage />} />
      <Route path="/" element={<ListOrder />} />
      <Route path="history/:id" element={<OrderHistoryDetail />} />
      <Route path="history" element={<OrderHistory />} />
    </Routes>
  );
};

export default Order;
